import { useRoles } from './authorization.hook';

/** Returns `true` if User has at least 1 of given `requiredRoles`.
 *
 * For AND logic a single entry in requiredRoles must be list of roles separated
 * by "&" character. Whitespace will be ignored.
 *
 * E.g. User must have `role1` OR (`role2` AND `role3`)
 * ```
 * roles = ['role1', 'role2 & role3']
 * ```
 */
export function useHasPermission() {
  const tokenRoles = useRoles();

  return (requiredRoles: string[]) => {
    for (const role of requiredRoles) {
      if (role.split('&').every((r) => tokenRoles?.includes(r.trim()))) {
        return true;
      }
    }
    return false;
  };
}
